import { IAppNavigationOptions } from '@apps-common/hooks/useNavigation'
import { ROUTE_CREATE_UNIT_ACTIVATION } from '@apps-radionet-portal-root/src/config/private-routes'

export const navigateActivationWithUnitDetails = (
  navigateForward: (opts: IAppNavigationOptions) => void,
  unitId: string,
  serialNo: string,
  imei: string
) => {
  navigateForward({
    routeUrl: `${ROUTE_CREATE_UNIT_ACTIVATION.buildPath()}?id=${unitId}&serialNo=${serialNo}&imei=${imei}`,
    route: ROUTE_CREATE_UNIT_ACTIVATION
  })
}
